import BusinessRounded from '@mui/icons-material/BusinessRounded';
import PeopleRounded from '@mui/icons-material/PeopleRounded';
import { styled } from '@mui/material/styles';
import { useTranslation } from '@hooks';

export const OWNER_TYPE = {
    TEAM: 'team',
    LOCATION: 'location',
    BRAND: 'brand',
};

const markerStyles = {
    fontSize: 16,
    color: 'var(--primary-main)',
    flexShrink: 0,
};

const BrandIcon = styled(BusinessRounded)(markerStyles);
const TeamIcon = styled(PeopleRounded)(markerStyles);

// Locations are the default scope and stay unmarked, so they have no entry here.
const OWNER_MARKERS = {
    [OWNER_TYPE.TEAM]: { Icon: TeamIcon, labelKey: 'common.team' },
    [OWNER_TYPE.BRAND]: { Icon: BrandIcon, labelKey: 'common.brand' },
};

const OwnerIcon = ({ type }) => {
    const { t } = useTranslation();
    const { Icon, labelKey } = OWNER_MARKERS[type] ?? {};

    return Icon ? <Icon titleAccess={t(labelKey)} /> : null;
};

export default OwnerIcon;
